module.exports = __webpack_public_path__ + "static/media/VIKAS JI 25X50_page-0001.f85f6ae8.jpg";